import Vue from 'vue';

Vue.filter('Profile', (value) => {
    if (!value) return '';
    switch (value) {
        case 'ADMIN':
            return 'Administrador';
        case 'USER':
            return 'Usuário';
        default:
            return 'Usuário';
    }
});
